import LinkIfFullyAuthenticated from './link-if-fully-authenticated';
export default LinkIfFullyAuthenticated;
